/**
 * Project menus
 *
 * @package ARS Webapp
 * @author René Schulze <schulze@thadeus-roth.de>
 */

import { ref } from 'vue';
import config from '?/Config';
import { t } from '?/Composable/Translation';

let mainMenu;

mainMenu = [
    // {
    //     name: t('webapp.news'),
    //     classes: 'news',
    //     to: '/webapp/',
    //     ref: ref(),
    //     visible: true
    // },
    {
        name: t('webapp.stations'),
        classes: 'stations',
        to: '/webapp/station',
        ref: ref(),
        visible: true
    },
    {
        name: t('webapp.knights'),
        classes: 'knights',
        to: '/webapp/knights',
        ref: ref(),
        visible: true
    },
    {
        name: t('webapp.stories'),
        classes: 'stories',
        to: '/webapp/story',
        ref: ref(),
        visible: true
    },
    {
        name: t('webapp.points'),
        classes: 'points break-after',
        to: '/webapp/points',
        ref: ref(),
        visible: true
    },
    {
        name: t('webapp.hostels'),
        classes: 'hostels',
        to: '/webapp/hostels',
        ref: ref(),
        visible: true
    },
    {
        name: t('webapp.team'),
        classes: 'team',
        to: '/webapp/team',
        ref: ref(),
        visible: (config.allowTeams)
    },
    {
        name: t('webapp.help'),
        classes: 'help',
        to: '/webapp/help',
        ref: ref(),
        visible: true
    },
    {
        name: t('webapp.privacy'),
        classes: 'privacy',
        to: '/webapp/privacy',
        ref: ref(),
        visible: true
    },
    {
        name: t('webapp.logout'),
        classes: 'logout',
        to: '/webapp/logout',
        ref: ref(),
        visible: (!config.registrationlessLogin)
    },
    {
        name: t('webapp.change-password'),
        classes: 'change-password',
        to: '/webapp/password',
        ref: ref(),
        visible: (!config.registrationlessLogin)
    },
    {
        name: t('webapp.delete-account'),
        classes: 'delete-account',
        to: '/webapp/end',
        ref: ref(),
        visible: true
    }
];

export { mainMenu };
